import _ from 'lodash';
import { cardShape } from '@editor/droplets/utils';

export default function cardsStep() {
  return {
    _id: false,
    type: 'droplet.cardsStep',
    cards: _.times(4, cardShape({ type: 'droplet.cardsStep.cardItem', mediaQueries: [] })),
    mediaQueries: [
      {
        selector: '.drzCard-stepArrow',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(0, 0, 0, 0.3)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzCard-step-inner',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    activeCard: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-step/droplet.schema.js